import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery page">
      <Header />

      <div className="main-content ecm-content shipping-delivery-rj-us customer-service">
        <div
          id="text1726442547"
          className="text section primary-header ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h1>Shipping &amp; Order Processing</h1>
          <p>Our products are delivered in the following ways:</p>
          <ul>
            <li>
              Front Door Parcel Delivery (e.g., UPS, USPS) to your delivery
              address.
            </li>
            <li>
              Flat Rate Home Delivery for most furniture and other items that
              exceed parcel carrier shipping weight limits; usually includes our
              Premium White Glove service and Unlimited Items for a Flat Rate
              fee. Doorstep Delivery may be available at a reduced Flat Rate;
              does not include assembly and you are responsible for bringing the
              items into your home.
            </li>
          </ul>
        </div>
        <div
          id="text-277295935"
          className="text section front-door-parcel-delivery ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h2>Front Door Parcel Delivery</h2>
          <h3>Standard Shipping</h3>
          <p>
            Front Door items ship from our warehouse and arrive within 4-5
            business days of receiving your order. Some items sent directly from
            our suppliers may take longer, and items ordered together may not
            arrive in the same box.
          </p>
          <h3>Next Day Shipping</h3>
          <p>
            For an extra charge of $27.50 per address, we can arrange for next
            day delivery to most destinations within the contiguous 48 states.
            If we receive your order by 4pm PT Monday through Friday, you'll
            receive your order the next business day; orders placed Friday after
            4pm through Sunday will arrive on Tuesday.
          </p>
          <h2>Flat Rate Delivery</h2>
          <h3>White Glove Delivery*</h3>
          <p>
            Your order will ship when all items in your order are available for
            delivery. Items are delivered to your home by appointment to your
            room of choice— and are then unpacked and fully assembled. *Items
            that do not include full assembly are outdoor patio structures,
            marble or stone sink consoles, lighting, mirrors, rugs, headboards
            attached to a metal frame and any items requiring home installation.
          </p>
          <h3>Doorstep Delivery</h3>
          <p>
            Doorstep Delivery service is available for select items at a lower
            flat rate. With Doorstep Delivery you are responsible for bringing
            items into your home, assembly is not included. For multi-unit
            buildings, items will be placed in a secure lobby area or with
            building concierge.
          </p>
          <p className="fees">
            Fees:&nbsp;Flat Rate fees and/or parcel carrier delivery and
            processing charges are shown under Shipping Rates, and will be
            applied in the Checkout Payment and Review page.
          </p>
          <h3>Gift Cards</h3>
          <p>
            Gift cards have slightly different rates and time frames from other
            products:
          </p>
          <ul>
            <li>
              Free shipping by USPS with standard delivery (5-7 business days).
            </li>
            <li>
              Next day delivery available for a $12.00 charge – arrives in 1
              business day if placed by 9am PT Mon – Fri.
            </li>
            <li>
              Orders placed after 9am PT Friday through Sunday will arrive on
              Tuesday.
            </li>
          </ul>
          <h3 className="apo-fpo-delivery-header">
            Deliveries to Alaska, Hawaii, US Territories, and Military Addresses
            (APO/FPO)
          </h3>
          <p>
            Items shipped to Alaska, Hawaii and U.S. territories are delivered
            by USPS with an additional charge of $20. Some heavy or oversized
            items cannot be shipped outside the contiguous 48 states. The
            standard shipping charge applies to orders shipped to APO/FPO
            addresses and will arrive within 4 to 6 weeks.
          </p>
        </div>
        <div
          id="text2035065857"
          className="text section secondary-header ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h2>Shipping Rates &amp; Fees</h2>
          <p className="shipping-rates-copy">
            Our shipping and processing fees cover the processing, handling,
            packing and delivery of your order. Delivery fees do not include
            gift wrap or surcharges that may apply to some items.
          </p>
          <h3>Front Door Parcel Delivery - Standard and Next-Day*</h3>
          <p className="shipping-rates-copy">
            SHIPPING RATES - to contiguous 48 states
          </p>
        </div>
        <div
          id="text-123248303"
          className="text section front-door-parcel-delivery-table ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <div className="us-shipping-rates-table">
            <table className="border flat-rate-table">
              <tbody>
                <tr>
                  <th>
                    <h3>Order Total</h3>{" "}
                  </th>
                  <th>
                    <h3>Standard Shipping</h3>{" "}
                    <h4>
                      arrives in 4-5 business days
                      <br /> personalized items add 2 days
                    </h4>{" "}
                  </th>
                  <th>
                    <h3>Next Day Shipping</h3>{" "}
                    <h4>
                      add $27.50 to standard fee
                      <br /> order by 4pm PT Mon-Fri
                    </h4>{" "}
                  </th>
                </tr>
                <tr>
                  <td className="order-total">Up to $15.00</td>
                  <td className="std-shipping">$5.95</td>
                  <td className="next-day-shipping">$33.45</td>
                </tr>
                <tr>
                  <td className="order-total">$15.01 - $25.00</td>
                  <td className="std-shipping">$7.00</td>
                  <td className="next-day-shipping">$34.50</td>
                </tr>
                <tr>
                  <td className="order-total">$25.01 - $45.00</td>
                  <td className="std-shipping">$9.50</td>
                  <td className="next-day-shipping">$37.00</td>
                </tr>
                <tr>
                  <td className="order-total">$45.01 - $65.00</td>
                  <td className="std-shipping">$12.95</td>
                  <td className="next-day-shipping">$40.45</td>
                </tr>
                <tr>
                  <td className="order-total">$65.01 - $90.00</td>
                  <td className="std-shipping">$16.00</td>
                  <td className="next-day-shipping">$43.50</td>
                </tr>
                <tr>
                  <td className="order-total">$90.01 - $125.00</td>
                  <td className="std-shipping">$19.00</td>
                  <td className="next-day-shipping">$46.50</td>
                </tr>
                <tr>
                  <td className="order-total">$125.01 - $200.00</td>
                  <td className="std-shipping">$24.00</td>
                  <td className="next-day-shipping">$51.50</td>
                </tr>
                <tr>
                  <td className="order-total">$200.00 - $300.00</td>
                  <td className="std-shipping">$29.00</td>
                  <td className="next-day-shipping">$56.50</td>
                </tr>
                <tr>
                  <td className="order-total">$300.01 &amp; over</td>
                  <td className="std-shipping">10%</td>
                  <td className="next-day-shipping">N/A</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="std-processing-charges">
            *Note: Standard shipping and processing charges are applied for each
            delivery address on an order. Next Day Delivery service is not
            available for some oversize items, Premium In-Home White Glove
            Delivery items, out of stock items, items on backorder,
            personalized/monogrammed items, items shipped directly from the
            manufacturer or for items shipped outside the contiguous 48 states.
            Please call 1.888.401.1900 for more information.
          </p>
        </div>
        <div
          id="text-905930903"
          className="text section front-door-parcel-delivery-table us-territories-shipping-rates ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <p>SHIPPING RATES - Alaska, Hawaii and U.S. Territories</p>
          <div className="us-territories-shipping-rates-table">
            <table className="border flat-rate-table">
              <tbody>
                <tr>
                  <th>
                    <h3>Destination</h3>{" "}
                  </th>
                  <th>
                    <h3>Standard Shipping</h3>{" "}
                  </th>
                  <th>
                    <h3>Arrives</h3>{" "}
                  </th>
                </tr>
                <tr>
                  <td className="order-total">Alaska</td>
                  <td className="std-shipping">Add $20 to standard fee</td>
                  <td className="next-day-shipping">5 business days</td>
                </tr>
                <tr>
                  <td className="order-total">Hawaii</td>
                  <td className="std-shipping">Add $20 to standard fee</td>
                  <td className="next-day-shipping">5 business days</td>
                </tr>
                <tr>
                  <td className="order-total">U.S. Territories</td>
                  <td className="std-shipping">Add $20 to standard fee</td>
                  <td className="next-day-shipping">10-15 business days</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          id="text-639207853"
          className="text section white-glove-delivery ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h3>White Glove Delivery - Unlimited Flat Rate</h3>
        </div>
        <div
          id="imagerollover1312494616"
          className="section imagerollover ecm-component-wrapper ecm-image-wrapper responsive-devicetype-desktop responsive-devicetype-mobile shipping-delivery-img "
        >
          <img
            alt="White Glove Delivery"
            className=" "
            title="White Glove Delivery"
            src="https://assets.rjimgs.com/rjimgs/rk/images/dp/ecm/202524/0309/001/216.png"
          />
        </div>
        <div
          id="text-1518366045"
          className="text section white-glove-delivery-list ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <ul>
            <li>
              White Glove Delivery charge is a flat rate based on two factors:
              (1) the distance from our warehouse to your location, and (2) the
              amount of your overall order.
            </li>
            <li>
              Refer to the local/regional/national delivery zones table and
              rates tables.
            </li>
            <li>Available in the contiguous 48 states only.</li>
          </ul>
        </div>
        <div
          id="text16525772"
          className="text section ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <p>
            Eligible items will show "White Glove Delivery" on the product
            page.&nbsp;Pool tables, pool and table tennis covers, foosball
            tables, and air hockey tables are not eligible for White Glove
            Delivery.
          </p>
        </div>
        <div
          id="text-1110466193"
          className="text section local-regional-national-del-zone ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <div className="us-shipping-rates-table local-regional-national-del-zone-table">
            <table className="border flat-rate-table">
              <tbody>
                <tr>
                  <th>
                    <h3>Distance</h3> <h4>to your location</h4>{" "}
                  </th>
                  <th>
                    <h3>Flat Rate Charge</h3> <h4>Orders to $999</h4>{" "}
                  </th>
                  <th>
                    <h3>Flat Rate Charge</h3> <h4>Orders over $999</h4>{" "}
                  </th>
                </tr>
                <tr>
                  <td className="order-total">Local (0-50 miles)</td>
                  <td className="std-shipping">$159</td>
                  <td className="next-day-shipping">$279</td>
                </tr>
                <tr>
                  <td className="order-total">Metro (51-99 miles)</td>
                  <td className="std-shipping">$179</td>
                  <td className="next-day-shipping">$299</td>
                </tr>
                <tr>
                  <td className="order-total">Regional (100-199 miles)</td>
                  <td className="std-shipping">$209</td>
                  <td className="next-day-shipping">$379</td>
                </tr>
                <tr>
                  <td className="order-total">National (200 miles + up)</td>
                  <td className="std-shipping">$309</td>
                  <td className="next-day-shipping">$429</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          id="text1586094527"
          className="text section ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h3>Delivery Timing</h3>
          <p>
            Speed of delivery depends on type of product, product availability,
            and proximity to metropolitan areas*. Backordered items will ship
            once back in stock, at no extra charge.
          </p>
          <div className="us-shipping-rates-table local-regional-national-del-zone">
            <table className="border flat-rate-table">
              <tbody>
                <tr>
                  <th>
                    <h3>Type of Item</h3>{" "}
                  </th>
                  <th>
                    <h3>Delivery Timing</h3>{" "}
                  </th>
                </tr>
                <tr>
                  <td className="order-total">
                    Non-Upholstered Furniture - within metro areas*
                  </td>
                  <td className="std-shipping">7-10 business days</td>
                </tr>
                <tr>
                  <td className="order-total">
                    Non-Upholstered Furniture - outside metro areas*
                  </td>
                  <td className="std-shipping">2-4 weeks</td>
                </tr>
                <tr>
                  <td className="order-total">Quick-Ship Upholstered</td>
                  <td className="std-shipping">1-5 weeks</td>
                </tr>
                <tr>
                  <td className="order-total">Special Order Upholstery</td>
                  <td className="std-shipping">
                    8-10 weeks, or as otherwise indicated on the product page
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          id="text-271162934"
          className="text section doorstep-delivery-container ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <p>
            * Metropolitan areas: San Francisco, Los Angeles, Las Vegas, Denver,
            Phoenix, New York City, Baltimore, Boston, Dallas, Atlanta, Chicago,
            Detroit, Columbus, Cromwell CT, Raleigh/Charlotte NC, Tampa/Ft.
            Myers/Orlando, Miami/Ft. Lauderdale.
          </p>
          <h3>Arranging Delivery</h3>
          <p>
            White Glove Delivery is by appointment Tuesday-Saturday in most
            major metropolitan areas, with Monday delivery available in some
            areas. Service to outlying areas may be restricted based on
            geographic location. A service representative will contact you to
            arrange a delivery date and confirm the appointment timeframe
            (typically a 4-hour window).
          </p>
          <p>Doorstep Delivery - Reduced Flat Rate</p>
          <div className="us-shipping-rates-table doorstep-delivery">
            <table className="border flat-rate-table">
              <tbody>
                <tr>
                  <th>
                    <h3>Order Total</h3>{" "}
                  </th>
                  <th>
                    <h3>Order Total</h3> <h4>Up to $499</h4>{" "}
                  </th>
                  <th>
                    <h3>Order Total</h3> <h4>Up to $999</h4>{" "}
                  </th>
                  <th>
                    <h3>Order Total</h3> <h4>Over $999</h4>{" "}
                  </th>
                </tr>
                <tr>
                  <td className="order-total">Local</td>
                  <td className="std-shipping">$59</td>
                  <td className="std-shipping">$79</td>
                  <td className="std-shipping">$159</td>
                </tr>
                <tr>
                  <td className="order-total">Metro</td>
                  <td className="std-shipping">$69</td>
                  <td className="std-shipping">$99</td>
                  <td className="std-shipping">$179</td>
                </tr>
                <tr>
                  <td className="order-total">Regional</td>
                  <td className="std-shipping">$99</td>
                  <td className="std-shipping">$129</td>
                  <td className="std-shipping">$259</td>
                </tr>
                <tr>
                  <td className="order-total">National</td>
                  <td className="std-shipping">$159</td>
                  <td className="std-shipping">$209</td>
                  <td className="std-shipping">$309</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          id="text-2141995973"
          className="text section ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <p>
            Doorstep Delivery service is available for select items at a lower
            flat rate. With Doorstep Delivery you are responsible for bringing
            the item into your home. Assembly and packaging disposal is not
            included in Doorstep Delivery.
          </p>
          <div className="us-shipping-rates-table doorstep-delivery">
            <table className="border flat-rate-table">
              <tbody>
                <tr>
                  <th>
                    <h3>Destination</h3>{" "}
                  </th>
                  <th>
                    <h3>Standard Shipping</h3>{" "}
                  </th>
                  <th>
                    <h3>Arrives</h3>{" "}
                  </th>
                </tr>
                <tr>
                  <td className="order-total">Alaska</td>
                  <td className="std-shipping">Add $20 to standard fee</td>
                  <td className="std-shipping">5 business days</td>
                </tr>
                <tr>
                  <td className="order-total">Hawaii</td>
                  <td className="std-shipping">Add $20 to standard fee</td>
                  <td className="std-shipping">5 business days</td>
                </tr>
                <tr>
                  <td className="order-total">U.S. Territories</td>
                  <td className="std-shipping">Add $20 to standard fee</td>
                  <td className="std-shipping">10-15 business days</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          id="text635997449"
          className="text section ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h3>Gift Cards - Standard and Next-Day</h3>
        </div>
        <div
          id=""
          className="ecm-component-wrapper ecm-column-control responsive-devicetype-desktop responsive-devicetype-mobile parsys_column wsi-colctrl-lt1a white-glove-delivery-section gift-cards-std-section"
        >
          <div className="parsys_column wsi-colctrl-lt1a-c0 ">
            <div
              id="text821756817"
              className="text section white-glove-delivery-list ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
            >
              <p>
                Gift cards have slightly different rates and time frames from
                other products:&nbsp;
              </p>
              <ul>
                <li>
                  Free shipping by USPS with standard delivery (5-7 business
                  days).
                </li>
                <li>
                  Next day delivery is available for an $12 charge – arrives in
                  1 business day if placed by 9am PT Mon-Fri.
                </li>
                <li>
                  Orders placed after 9am PT Friday through Sunday will arrive
                  on Tuesday.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{ clear: "both" }} />
        <div
          id="text-1941003518"
          className="text section sales-tax ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h3>Sales Tax</h3>
          <p>
            Sales tax on the merchandise total is charged for items shipped to
            the following states and US territories: AL*, AR*, AZ*, CA*, CO*,
            CT*, DC*, FL*, GA*, IA, ID, IL*, IN*, KS*, KY*, LA*, MA, MD*, ME*,
            MI*, MN*, MO*, MS*, NC*, ND*, NE*, NJ*, NM*, NV*, NY*, OH*, OK, PA*,
            RI*, SC*, SD*, TN*, TX*, UT, VA*, VT*, WA*, WI*, WV*, WY and Puerto
            Rico*. States and US territories marked with an asterisk also
            collect taxes on shipping and processing charges. Except as
            otherwise noted, all sales are made by Williams-Sonoma DTC, Inc.,
            and the local sales tax of the delivery destination is also charged.
            All sales shipped to Texas locations are made by Williams-Sonoma DTC
            Texas, Inc., and the sales tax is based on the location where the
            order was received. The local sales tax of the delivery destination
            is also charged. Orders delivered to California locations are F.O.B.
            destination point which means title passes in California.
          </p>
          <h3>Shipping To APO/FPO Address</h3>
          <p>
            If you have an U.S. billing address and are shipping to an APO/FPO
            address, please proceed through the domestic checkout process.
          </p>
        </div>
        <div
          id="text1477975283"
          className="text section secondary-header ecm-component-wrapper ecm-text-wrapper responsive-devicetype-desktop responsive-devicetype-mobile"
        >
          <h2>Order Processing</h2>
          <p className="shipping-rates-copy">
            When placing an order online, in-store, or over the phone, please
            note that your credit or debit card will be charged at the time of
            purchase for certain items. These items include, but may not be
            limited to, made-to-order furniture, branded appliances, cookware,
            artwork, lighting, textiles, bath and kitchen hardware, bed and bath
            items, cookbooks, specific perishable foods, as well as small
            furniture items that are shipped via UPS. This policy also extends
            to items sold by third-party vendors, often referred to as drop
            shippers, who directly ship to customers.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Delivery;
